import { FormInstance } from 'antd/lib/form';
import decodeApiMessage from 'common/helper/decodeApiMessage';
import { notifyError, notifySuccess } from 'common/helper/notifications';
import { SubjectModel } from 'data/subject/subject.model';
import { onGetSubjects, onSetSubject } from 'data/subject/subject.service';
import { useDispatch } from 'react-redux';
import subjectSlice from 'redux/slice/subject.slice';

export const useSubject = () => {
  const dispatch = useDispatch();

  const fetchSubject = async () => {
    dispatch(subjectSlice.actions.setLoading());
    try {
      const res = await onGetSubjects();
      dispatch(subjectSlice.actions.setData(res));
    } catch (err) {
      dispatch(subjectSlice.actions.setError(err));
    }
  };

  const onSaveSubject = async (
    payload: SubjectModel,
    form: FormInstance,
    onVisibleChange: any,
    onReload: any,
  ) => {
    try {
      await onSetSubject(payload).then(() => {
        form.resetFields();
        onVisibleChange(false);
        onReload(true);
      });
      notifySuccess('Success', 'Subject successfully added.');
    } catch (err) {
      onVisibleChange(true);
      onReload(false);
      notifyError('Error', decodeApiMessage(err));
    }
  };
  return { fetchSubject, onSaveSubject };
};
